'use client';

import '@ui5/webcomponents/dist/TabSeparator.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `TabSeparator` represents a vertical line to separate tabs inside a `TabContainer`
 *
 * @abstract
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-TabContainer)
 */
const TabSeparator = withWebComponent('ui5-tab-separator', [], [], [], []);
TabSeparator.displayName = 'TabSeparator';
export { TabSeparator };